"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _withIllustration = _interopRequireDefault(require("../withIllustration"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const IllustrationSemiDetachedHouse = props => {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("svg", {
    viewBox: "0 0 112 42",
    ...props,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
      stroke: "none",
      strokeWidth: "1",
      fill: "none",
      fillRule: "evenodd",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
            fill: "#FFFFFF",
            x: "0",
            y: "18",
            width: "88",
            height: "24"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
            fill: "#091E43",
            points: "12 2 100 2 88 18 0 18"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
            fill: "#C3D0D8",
            points: "88 18 100 2 112 18 112 42 88 42"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
            fill: "#C3D0D8",
            x: "48",
            y: "26",
            width: "8",
            height: "16"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
            fill: "#C3D0D8",
            x: "64",
            y: "26",
            width: "16",
            height: "8"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
            fill: "#C3D0D8",
            x: "8",
            y: "26",
            width: "16",
            height: "8"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
            fill: "#091E43",
            x: "96",
            y: "26",
            width: "8",
            height: "8"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
            fill: "#C3D0D8",
            x: "32",
            y: "26",
            width: "8",
            height: "16"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
            fill: "#FFFFFF",
            points: "16 0 22 0 22 10 16 10"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
            fill: "#FFFFFF",
            points: "72 0 78 0 78 10 72 10"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
            fill: "#C3D0D8",
            points: "22 -4.57966998e-15 25 -4.57966998e-15 25 5.99132231 22 10"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
            fill: "#C3D0D8",
            points: "78 -4.57966998e-15 81 -4.57966998e-15 81 5.99132231 78 10"
          })]
        })
      })
    })
  });
};
var _default = exports.default = (0, _withIllustration.default)('IllustrationSemiDetachedHouse')(IllustrationSemiDetachedHouse);